<div class="row">
    <div class="col-md-6 col-xl-3">
        <a [routerLink]=""
           class="card card-box card-box-hover-rise card-box-hover text-black align-box-row align-items-start mb-5 p-4">
            <div>
                <div class="display-3 font-weight-bold">
                    56
                </div>
                <div class="divider mt-2 mb-3 border-2 w-25 bg-first rounded border-first"></div>
                <div class="font-weight-bold text-black-50 font-size-sm text-uppercase">
                    Tasks done
                </div>
            </div>
            <div class="ml-auto card-hover-indicator align-self-center">
                <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
            </div>
        </a>
    </div>
    <div class="col-md-6 col-xl-3">
        <a [routerLink]=""
           class="card card-box card-box-hover-rise card-box-hover text-black align-box-row align-items-start mb-5 p-4">
            <div>
                <div class="display-3 font-weight-bold text-danger">
                    18
                </div>
                <div class="divider mt-2 mb-3 border-2 w-25 bg-danger rounded border-danger"></div>
                <div class="font-weight-bold text-black-50 font-size-sm text-uppercase">
                    Requests
                </div>
            </div>
            <div class="ml-auto card-hover-indicator align-self-center">
                <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
            </div>
        </a>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box text-black-50 mb-5 p-4">
            <div class="display-3 text-black font-weight-bold">
                29
            </div>
            <div class="divider mt-2 mb-3 border-2 w-25 bg-success rounded border-success"></div>
            <div class="font-weight-bold font-size-sm text-uppercase">
                Bugfixes
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box text-black-50 mb-5 p-4">
            <div class="display-3 text-black font-weight-bold">
                768
            </div>
            <div class="divider mt-2 mb-3 border-2 w-25 bg-success rounded border-success"></div>
            <div class="font-weight-bold font-size-sm text-uppercase">
               Tickets
            </div>
        </div>
    </div>
</div>
